/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import {
	Alert,
	Breadcrumb,
	Button,
	Loading,
	Table as TableComponent,
	ConfirmationModal
} from "../../Components";
import Actions from "../../Components/GridComponents/Actions";
import 'react-dates/initialize';
import { GLOBAL } from "../../Config/global";
import "font-awesome/css/font-awesome.min.css";
import { APPCONFIG } from '../../app.config';
import * as QLIBS from '../../qLibsHelpers';
import { DEFAULT_HEADER } from '../../Config/userToken';
import NotificationRowDetail from './partials/notificationRowDetail';


class AdminNotificaciones extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			showDeleteModal: false,
			showNotificationDefinitionModal: false,
			showViewsModal: false,
			showGrid: false,
			rowId: 0,
			loadingData: false
		};
		this.searchResultsError = "";

		this.detailsColumn = {
			Header: "",
			accessor: "actions",
			width: 100,
			style: {
				display: 'flex',
				alignItems: 'center'
			},
			filterable: false,
			sortable: false,
			resizable: true,
			Cell: row => (
				<>
					<Actions
						icon="fa fa-edit"
						onDownload={() => this.detailsItem(row)}
					/>
					<Actions
						icon="fa fa-remove"
						onDownload={() => this.removeItem(row)}
					/>
				</>
			)
		};

		this.baseTableColumns = this.createBaseTableColumns();
		this.listTableColumns = this.createListTableColumns();

		this.loadGrid = this.loadGrid.bind(this);
		this.deleteNotificationDefinition = this.deleteNotificationDefinition.bind(this);
		this.handleResponse = this.handleResponse.bind(this);
		this.handleMuevo = this.handleMuevo.bind(this);
		this.detailsItem = this.detailsItem.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.exitDeleteModal = this.exitDeleteModal.bind(this);
	}

	componentDidMount() {

		this.handleResponse([]);
		this.loadGrid();

	}

	detailsItem = event => {
		this.setState({ rowId: event.row._original.id, showNotificationDefinitionModal: true });
	}

	removeItem = event => {
		this.setState({ rowId: event.row._original.id, showDeleteModal: true });
	}

	deleteNotificationDefinition = () => {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		this.searchResultsError = "";

		this.setState({loadingData: true });

		const id = this.state.rowId;

		// Parse data to send
		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get()
		};				
		return fetch(`${PRODUCERURL}api/notification/DeleteNotificationDefinition?Id=${id}`, requestOptions)
		.then((response) => {
			if (response.ok) {
				this.loadGrid();
			}
			else {
				this.searchResultsError = `Error procesando solicitud: ${response.statusText}`;
				this.setState({loadingData: false, showGrid: false });
			}
		});
	}

	loadGrid = () => {
		const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
		this.searchResultsError = "";

		this.setState({loadingData: true });

		// Parse data to send
		const requestOptions = {
			method: 'GET',
			headers: DEFAULT_HEADER.get()
		};				
		return fetch(`${PRODUCERURL}api/notification/SearchNotificationDefinition`, requestOptions)
		.then((response) => {
			if (response.ok) {
				QLIBS.authorizeAction(response)
				.then(this.handleResponse)
				.catch(this.handleResponse);
			}
			else {
				this.searchResultsError = `Error procesando solicitud: ${response.statusText}`;
				this.setState({loadingData: false, showGrid: false });
			}

		  })
	}

	handleResponse(response) {
		const { COMMON_SEARCH_FORM } = GLOBAL;

		let tableData = [];
		if (Array.isArray(response)) {
			this.searchResultsError = "";

			tableData = response.map(function (item) {

				return {
					...item,
					editMessageDesc: (item.EditMessage) ? 'Sí' : 'No',
					editDestinationDesc: (item.EditDestination) ? 'Sí' : 'No',
					editSchedulerDesc: (item.EditScheduler) ? 'Sí' : 'No',
					webUseDesc: (item.webUse) ? 'Sí' : 'No',
					mailUseDesc: (item.mailUse) ? 'Sí' : 'No',
					enabledDesc: (item.enabled) ? 'Sí' : 'No'
				}
			});

		}
		else {
			this.searchResultsError = COMMON_SEARCH_FORM.SERVER_ERROR;
		}

		this.listTableColumns = this.createListTableColumns();

		this.searchTableData = {
			makeData: () => {
				return tableData
			}
		};

		this.setState({ name: this.state.name, loadingData: false, showGrid: true });
	}


	createListTableColumns() {
		const newTableColumns = [this.detailsColumn, ...this.baseTableColumns.filter(f => f.show)];
		return newTableColumns;
	}

	createBaseTableColumns() {
		let newTableColumns = [];

		// Get Columns identifier
		let columns = {
			"description": { title: "Descripción", field: "Description", show: true },
			"editMessageDesc": { title: "Edita Texto", field:"EditMessageDesc", show: true, width: 140 },
			"editDestinationDesc": { title: "Edita Destino", field:"EditDestinationDesc", show: true, width: 150 },
			"editSchedulerDesc": { title: "Edita Calendario", field:"EditSchedulerDesc", show: true, width: 170 },
			"webUseDesc": { title: "Aplica Web", field:"webUseDesc", show: true, width: 150 },
			"mailUseDesc": { title: "Aplica E-Mail", field:"MailUseDesc", show: true, width: 150 },
			"enabledDesc": { title: "Habilitado", field:"EnabledDesc", show: true, width: 140 }
		};

		// Add Columns to Table
		let cols = QLIBS.getTableColumns(columns);
		cols.forEach((c) => { newTableColumns.push(c) });

		return newTableColumns;
	}


	exitDeleteModal(confirm) {
		this.setState({ showDeleteModal: false });
		if (confirm) {
			this.deleteNotificationDefinition();
		}
	}

	exitNotificationDefinitionModal(reload) {
		this.setState({ showNotificationDefinitionModal: false });
		if (reload) {
			this.loadGrid();
		}
	}

	handleMuevo() {
		this.setState({ rowId: 0, showNotificationDefinitionModal: true });
	}

	render(...props) {
		const { PAGES } = GLOBAL;

		return (
			<>
			
				{this.state.showDeleteModal && (
					<ConfirmationModal
						message={GLOBAL.TABLE_VIEW.DELETE_MODAL_BODY}
						status="primary"
						title={GLOBAL.TABLE_VIEW.DELETE_MODAL_TITLE}
						onDismiss={() => { this.exitDeleteModal(false) }}
						onConfirm={() => { this.exitDeleteModal(true) }}
					/>
				)}				
				<Loading visible={this.state.loadingData}></Loading>
				
				<section className="col-12">
					<div className="row">
						<div className="col-12">
							<Breadcrumb currentPage="/adminnotificaciones" />
						</div>
						<div className="col-12">
							<h4 className="form-title">{PAGES.TITLE.ADMINNOTIFICATION}</h4>
						</div>
						<div className="form-container container table-view col-md-12 mt-2">

							{this.searchResultsError && (
								<div id="form-error-message" className="row my-2">
									<div className="col-12">
										<Alert
											icon="times"
											message=""
											title={this.searchResultsError}
											errorInfo={this.searchResultsError}
											type="error"
										/>
									</div>
								</div>
							)}
							<div className="row col-12 my-3">
								<div className="search-buttons">
									<Button type="button" id="btnNuevo" onClick={() => { this.handleMuevo() }} classes="to-bottom button-small search-button"><span className="fa fa-plus"> </span> Nueva Notificación</Button>
								</div>
							</div>
							{this.state.showGrid && (
								<div className="row my-3">
									<div className="col-12 px-3">
										{<TableComponent
											columns={this.listTableColumns}
											data={this.searchTableData.makeData()}
											subComponent={props => (
												<NotificationRowDetail width={(window.innerWidth - 120)} {...props} />
											)}
											expandable={true} {...props}
										/>}
									</div>
								</div>
							)}
						</div>
					</div>
				</section>
			</>
		);
	}
}

export default AdminNotificaciones;